import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customcount'
})

export class CustomCountPipe implements PipeTransform {
  transform(value: number, ...args: any[]): string {
    return value < 9 && value > 0 ? '0' + value?.toString() : value?.toString();
  }
}
